import { NavItem } from '../../nav/primitives/nav-item';
import { useContactsNavItem } from './use-contacts-nav-item';

export const ContactsNavItem = () => {
  const item = useContactsNavItem();
  return <NavItem item={item} />;
};
